/* eslint-disable no-debugger */
import { GET_RAN_SITES_BY_STATUS } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getRanSitesByStatus = async (status) => {
  try {
    const response = await apiClient.get(GET_RAN_SITES_BY_STATUS(status, 'ran'));
    console.log('response', response?.data?.response);
    return response?.data?.response || response?.data;
  } catch (error) {
    handleApiError(error);
  }
};
